import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"

import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { NavigationItem } from "@molecules"

export default function HelpCenter() {
    const { openHelpCenter } = useUserNavigationUtils()

    return (
        <NavigationItem
            onClick={() => openHelpCenter()}
            variant="secondary"
            label="Help Center"
            icon={icon({ name: "question-circle", style: "regular", family: "sharp" })}
            iconActive={icon({ name: "question-circle", style: "solid", family: "sharp" })}
        />
    )
}
